import React, { createContext, useContext } from "react";
import ReactDOM from "react-dom/client";

export default function confirmPopup({message = "Are you sure?", textY = "Confirm", textN = "Cancel"}) {
  return new Promise((resolvePromise) => {
    const container = document.createElement("div");
    container.style =
      "position:fixed;top:0;width:100%;height:100vh;display:flex;justify-content:center;align-items:center;background-color:#0000004f";
    document.body.appendChild(container);

    const root = ReactDOM.createRoot(container);

    const resolve = (value) => {
      root.unmount();
      container.remove();
      resolvePromise(value);
    };

    root.render(
      <div className="w-full max-w-lg h-min px-2 py-3 text-center bg-slate-50 rounded-lg">
        <p>{message}</p>
        <hr />
        <div className="flex justify-around">
          <button className="rounded-lg bg-white border py-1 px-2" onClick={() => resolve(false)}>
            {textN}
          </button>
          <button className="rounded-lg bg-white border py-1 px-2" onClick={() => resolve(true)}>
            {textY}
          </button>
        </div>
      </div>
    );
  });
}
